import { render, staticRenderFns } from "./UserProfile.vue?vue&type=template&id=a2741d4c&"
import script from "./UserProfile.vue?vue&type=script&lang=js&"
export * from "./UserProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2741d4c')) {
      api.createRecord('a2741d4c', component.options)
    } else {
      api.reload('a2741d4c', component.options)
    }
    module.hot.accept("./UserProfile.vue?vue&type=template&id=a2741d4c&", function () {
      api.rerender('a2741d4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/chat/UserProfile.vue"
export default component.exports